import { type FC } from "react";
import { Badge } from "antd";

import { CalendarEventStatus } from "@fitness-app/data-models/entities/CalendarEvent";

interface CalendarEventStatusBadgeProps {
  status: CalendarEventStatus;
}

const statusColors = {
  [CalendarEventStatus.ACTIVE]: "processing",
  [CalendarEventStatus.CANCELED]: "error",
  [CalendarEventStatus.NO_SHOW]: "warning",
  [CalendarEventStatus.ATTENDED]: "success",
} as const;

export const calendarEventStatusLabels = {
  [CalendarEventStatus.ACTIVE]: "Zaplanowane",
  [CalendarEventStatus.CANCELED]: "Anulowane",
  [CalendarEventStatus.NO_SHOW]: "Nieobecny",
  [CalendarEventStatus.ATTENDED]: "Zaliczone",
};

export const CalendarEventStatusBadge: FC<CalendarEventStatusBadgeProps> = ({ status }) => {
  return <Badge status={statusColors[status]} text={calendarEventStatusLabels[status]} />;
};
